// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.role-table[data-v-dc09f8bc] {\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 4px;\n}\n.role-table th[data-v-dc09f8bc]:first-child, .role-table td[data-v-dc09f8bc]:first-child {\n  min-width: 200px;\n  max-width: 200px;\n}", ""]);
// Exports
module.exports = exports;
